var _g;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgMobileCallIcon = function SvgMobileCallIcon(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 67.494,
    height: 67.802,
    viewBox: "0 0 67.494 67.802",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-285.283 -116)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(285.283 116)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M61.891,218.026a33.163,33.163,0,0,1,66.265-.327c.022.483.035.967.032,1.452a32.652,32.652,0,0,1-4.593,16.577.472.472,0,0,0-.043.4l5.8,17.377a.3.3,0,0,1-.381.385l-18.044-5.826a.474.474,0,0,0-.368.033,33.466,33.466,0,0,1-15.67,3.827,33.074,33.074,0,0,1-33.015-33.06C61.872,218.621,61.891,218.026,61.891,218.026Z",
    transform: "translate(-61.871 -186.1)",
    fill: "#28aff7"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.966, 0.259, -0.259, 0.966, 276.912, -63.089)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M100.627,200.2a2.664,2.664,0,0,1-3.756,0l-7.5-7.5a2.664,2.664,0,0,1,0-3.756l1.771-1.771a1.22,1.22,0,0,0,0-1.726l-5.061-5.061a1.214,1.214,0,0,0-1.712-.014l-.009.009c-4.51,4.51-2.607,13.726,4.251,20.583s16.073,8.761,20.583,4.251l.009-.009a1.214,1.214,0,0,0-.014-1.712l-5.061-5.061a1.22,1.22,0,0,0-1.726,0Z",
    fill: "#fff"
  })))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgMobileCallIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/mobile-call-icon.3149e1ce.svg";
export { ForwardRef as ReactComponent };